import { AgsWin } from "ags/integration/schema/ags-spin-response-schema";
import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { Point } from "appworks/utils/geom/point";
import { LineResult } from "slotworks/model/gameplay/records/results/line-result";
import { slotDefinition } from "slotworks/model/slot-definition";
import { AgsResultBuilder } from "./abstract-ags-result-builder";

export class LineResultBuilder extends AgsResultBuilder {
    public filter(response: AgsWin): boolean {
        const isLineOrFreespinWin = response.evaluationType === "lines";// || response.evaluationType === "freeSpinWin";
        return isLineOrFreespinWin && response.lineNumber !== undefined;
    }

    public build(record: Record, response: AgsWin): Result[] {
        const symbolDefinition = slotDefinition.symbolDefinitions[response.symbolId];

        const result = new LineResult();
        result.symbolType = symbolDefinition.id;
        result.cashWon = response.winAmount;
        result.line = response.lineNumber;
        result.positions = response.winningSymbolsPositions
            .map((position) => new Point(position[0], position[1]));
        result.matches = response.winningSymbolsPositions.length;

        const freespinResults = this.processFreespinData(record, response, result);

        return [result, ...freespinResults];
    }
}
